import styled from 'styled-components'

const Line = styled.span`
  display: flex;
  flex-flow: row nowrap;

  &::before,
  &::after {
    content: '';
    display: block;
    flex: 0 0 62%;
    height: 2px;
    background: hsla(0, 0%, 0%, 1);
    transition: all 0.2s linear;
    transform-origin: center;
  }

  &::after {
    left: -17%;
    position: relative;
  }

  ${({ isOpen }) =>
    isOpen &&
    `
    &:nth-child(1)::before {
      transform: rotate(45deg);
    }

    &:nth-child(1)::after {
      transform: rotate(-45deg);
    }

    &:nth-child(3)::before {
      transform: rotate(-45deg);
    }

    &:nth-child(3)::after {
      transform: rotate(45deg);
    }

    &:nth-child(2)::before {
      transform: translateX(-4em);
      opacity: 0;
    }

    &:nth-child(2)::after {
      transform: translateX(4em);
      opacity: 0;
    }`};
`
const Container = styled.div`
  width: 4em;
  height: 3em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding: 1em;
  cursor: pointer;
`
export const Hamburger = ({ isOpen, onClick, className }) => (
  <Container isOpen={isOpen} onClick={onClick} className={className}>
    <Line isOpen={isOpen} />
    <Line isOpen={isOpen} />
    <Line isOpen={isOpen} />
  </Container>
)
